
export const changePortalIcon = (base64) => {
    const iconLink = document.querySelector("link[rel*='icon']") || document.createElement('link');
    iconLink['type'] = 'image/x-icon';
    iconLink['rel'] = 'icon';
    iconLink['href'] = base64;
    document.head.appendChild(iconLink);
  }